import InvertIntegrationIcon from './component'

export default InvertIntegrationIcon
